import React, {Component} from "react";
import './PisaasSignUpPopUp.css';
import Authentication from "../../authentication/Authentication";
import Api from "../../api/Api";

export default class PisaasSignUpPopUp extends Component {

    constructor() {
        super();
        this.state = {
            email: "",
            serviceName: "",
            serviceNameIsValid: true,
            showLoadAfterCreate: false,
            showErrorMessage: false,
            region: "eu-west-1",
            availableRegions: ["eu-west-1", "us-east-1"]
        };

        this.authentication = new Authentication();
    }

    handleEmailInput(event, event_tag) {
        this.setState({
            email: event.target.value
        })
    }

    handleServiceNameInput(event, event_tag) {
        const serviceName = event.target.value;

        if (serviceName.match(/^[a-z0-9]{1,22}$/)) {
            this.setState({
                serviceName: event.target.value,
                serviceNameIsValid: true,
                signupError: ""
            })
        } else {
            this.setState({
                serviceName: event.target.value,
                serviceNameIsValid: false,
                signupError: ""
            })
        }
    }

    successCallback = (data) => {
        this.setState({
            showLoadAfterCreate: false
        })
        this.props.refreshPisaasInstances(data);
        this.props.togglePopUp()
    }

    errorCallback = () => {
        this.setState({
            showLoadAfterCreate: false,
            showErrorMessage: true
        })
    }

    handleSignUp = () => {
        const {serviceName, email, region} = this.state;
        const currentPisaasPackageId = 7

        const api = new Api();

        if (this.state.serviceNameIsValid) {
            api.pisaasSignupUser(this.successCallback, this.errorCallback, email, serviceName, currentPisaasPackageId, region);
        }

        this.setState({
                showLoadAfterCreate: true
            }
        )
    }

    isEmpty = (str) => {
        return str.length === 0;
    }

    handleRegionChange = (event) => {
        this.setState({
            region: event.target.value
        })
    }

    render() {
        return (
            <div className={"pisaas-popup-container"} data-testid="pisaas.signUp.popup">
                <div className={"box"}>
                    <button className="try-pi-btn close-button" data-testid="pisaas.signUp.button.close" onClick={() => this.props.togglePopUp()}>X</button>
                    <h3 className={"title"} data-testid="pisaas.signUp.title">Sign up a user to Pisaas</h3>
                    <div className={"gap-top-4"}>
                        <span className={"field-name"} data-testid="pisaas.signUp.emailField">Email:</span>
                        <input onChange={(event) => this.handleEmailInput(event)} className="domain-input generic-input"
                               data-testid="pisaas.signUp.emailField.input" type="text"/>
                    </div>
                    <div className={"gap-top-4"}>
                        <span className={"field-name"} data-testid="pisaas.signUp.serviceNameField">Service Name:</span>
                        <input onChange={(event) => this.handleServiceNameInput(event)}
                               className="domain-input generic-input" data-testid="pisaas.signUp.serviceNameField.input" type="text"/>
                        {!this.state.serviceNameIsValid ?
                            <p className={"warning-text"} data-testid="pisaas.signUp.text.warning">Service name cannot contain capital letters, special
                                characters, spaces or be blank and more than 22 characters long</p> : <></>}
                        {this.state.showErrorMessage && !this.isEmpty(this.state.serviceName) ?
                            <p className={"warning-text"} data-testid="pisaas.signUp.text.warning">There was a problem signing up - please try again with a
                                different service name</p> : <></>}
                    </div>
                    <div className={"gap-top-4"}>
                        <span className={"field-name"} data-testid="pisaas.signUp.regionField">Region:</span>
                        <select onChange={(event) => this.handleRegionChange(event)} className={"generic-input"} data-testid="pisaas.signUp.regionField.select">
                            {this.state.availableRegions.map((region) => {
                                return (
                                    <option value={region}>{region}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className={"signup-buttons"}>
                        <button className={"try-pi-btn gap-top-4 btn-signup-cancel"}
                                data-testid="pisaas.signUp.button.cancel"
                                onClick={() => this.props.togglePopUp()}>CANCEL
                        </button>
                        {this.state.showLoadAfterCreate ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading"/> :
                            this.state.serviceNameIsValid && !this.isEmpty(this.state.email) && !this.isEmpty(this.state.serviceName) ?
                                <button className={"try-pi-btn gap-top-4 btn-create"} data-testid="pisaas.signUp.button.signUp" onClick={() => {
                                    this.handleSignUp()
                                }}>SIGN UP</button> :
                                <button className={"try-pi-btn gap-top-4 btn-create disabled"} data-testid="pisaas.signUp.button.signUp" disabled={true}>SIGN
                                    UP</button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}